import React, { useState } from 'react';
import css from './EmailSection.module.css';
import { useHistory } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { post } from '../../../../util/api';
import emailjs from '@emailjs/browser';

const EmailSection = () => {
  const history = useHistory();
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const submitDissabled = !name || !email || !recaptchaValue || submitted || loading;

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
    console.log('Captcha value:', value);
  };

  const handleSubmit = async (e) => {
    if (submitted || submitDissabled) return;
    setLoading(true);
    e.preventDefault();
    if (!recaptchaValue) {
      alert('Please complete the reCAPTCHA.');
      return;
    }
    // Save to Firebase
    await post('/api/firebase/add-batch', {
      collectionId: 'newsletter',
      items: [
        {
          id: email,
          email,
          name,
        },
      ],
    });

    // Send notification email to admin
    await emailjs.send(
      'service_ebopmj9',
      'template_af9qbi4',
      {
        from_name: name,
        from_email: email,
        to_email: 'scanwowmvp@gmail.com',
        message: `New newsletter signup:\nName: ${name}\nEmail: ${email}`,
      },
      'wH4gxUWkEjnvZh_DA'
    );

    setSubmitted(true);
    setLoading(false);
  };

  return (
    <div className={css.wrapper}>
      <div className={css.content}>
        <div className={css.left}>
          <p className={css.title}>Join the community</p>
          <p className={css.description}>
            Get fresh updates, featured scan stories, creative ideas, and exclusive platform tips
            delivered straight to your inbox. No spam. Just smart stuff worth scanning.
          </p>

          <div className={css.box}>
            <p className={css.boxTitle}>Let's meet up!</p>
            <p className={css.boxDescription}>
              From local demos to big trade shows — find out where the Scanwow crew is popping up
              next. We'd love to connect.
            </p>

            <button
              type="button"
              onClick={() => history.push('/coming-soon')}
              className={css.quickActionButton}
            >
              <span>Events Calendar</span>
            </button>
          </div>
        </div>
        <form className={css.right} onSubmit={handleSubmit}>
          <input
            placeholder="Your name*"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <input
            placeholder="Email address*"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            required
          />
          <div className={css.captchaWrapper}>
            <ReCAPTCHA
              sitekey={'6Ldf970sAAAAAMDBHKKI5QGXcUg__GTDfuMvGnXP'}
              onChange={handleRecaptchaChange}
              className={css.recaptchaWidget}
            />
          </div>
          <button
            type="button"
            onClick={handleSubmit}
            className={`${css.submitButton} ${submitDissabled && css.submitDissabled}`}
          >
            <span>{loading ? 'Loading...' : submitted ? 'Done' : 'Submit'}</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default EmailSection;
